import { createTRPCClient, httpBatchLink } from "@trpc/client"
import type { AppRouter } from "@carrot/bff/trpc/router"

export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: "/bff",
      fetch(url, options) {
        return fetch(url, {
          ...options,
          credentials: "include"
        })
      }
    })
  ]
})

// Debug hook — attach to window everywhere except production so engineers can call
// `await trpc.user.whoami.query()` from devtools on local dev and preview/stage URLs.
if (window.location.hostname !== "app.get-carrot.com") {
  const debugWindow = window as unknown as { trpc: typeof trpc }
  debugWindow.trpc = trpc
}
